// <reference path="../../../node_modules/msal/out/msal.d.ts" />

import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'

import { User } from '../_models/user.model';
import { JwtHelper, tokenNotExpired } from 'angular2-jwt';

import { environment } from '../../environments/environment';
import * as Msal from 'msal';

@Injectable()
export class AuthService {
    private applicationConfig: any = {
        //clientID: '462db165-b92e-4feb-a54c-0d96a8a72d21',
        clientID: 'c25205ad-9ef7-40bd-a4e0-195c0c44c196',
        graphScopes: ['user.read', 'profile']
    };

    private jwtHelper: JwtHelper = new JwtHelper();
    private token: string;
    private user: User;
    private app: any;

    constructor(private http: Http) {
        this.app = new Msal.UserAgentApplication(this.applicationConfig.clientID, '', () => {
            // callback for login redirect. not being used since we use popups
        });

        this.app.redirectUri = environment.apiUrl;
        this.app._postLogoutredirectUri = environment.apiUrl + 'account/login?logout=true';

        var token = localStorage.getItem('ppaauth');
        if (token && !this.jwtHelper.isTokenExpired(token)) {
            this.setLoggedIn(token);
        }
    }

    setLoggedIn(token) {
        localStorage.setItem('ppaauth', token);

        const user: User = new User();

        var claims = this.jwtHelper.decodeToken(token);
        user.Email = claims.email;
        user.GivenName = claims.given_name;
        user.Surname = claims.family_name;
        user.Id = claims.nameid;
        user.Role = claims.role;
        user.OfficeIds = claims.PMO;
        if (typeof user.OfficeIds === 'string') {
            user.OfficeIds = [user.OfficeIds];
        }

        this.user = user;
        this.token = token;
    }

    isLoggedIn(): Boolean {
        return this.user != null && !this.jwtHelper.isTokenExpired(this.token);
    }

    getUser(): User {
        return this.user;
    }

    loginPPA(aadToken: string): Observable<Response> {
        return this.http.post('/api/accounts/login', { token: aadToken })
            .map((response: Response) => {
                return response;
            })
            .catch((error: any) => {
                return Observable.throw(error.json());
            });;
    }

    loginAzureAD() {
        var user = this.app.getUser();
        if (!user) {
            this.app.loginRedirect(this.applicationConfig.graphScopes);
            return null;
        }

        return this.getTokenAzureAD();
    }

    silentLoginAzureAD() {
        var user = this.app.getUser();
        if (!user) {
            return null;
        }

        return this.getTokenAzureAD();
    }

    getTokenAzureAD() {
        return this.app.acquireTokenSilent(this.applicationConfig.graphScopes)
            .then(accessToken => {
                return decodeURIComponent(accessToken);
            },
            error => {
                if (error) {
                    this.app.acquireTokenRedirect(this.applicationConfig.graphScopes);
                }

                return error;
            });

    }

    logoutAzureAD() {
        return this.app.logout();
    }

    logoutPPA() {
        this.user = null;
        this.token = null;
        localStorage.removeItem('ppaauth');
    }
}



// WEBPACK FOOTER //
// ./Angular/app/_services/auth.service.ts